let $ = require( "jquery" );

$(function() {

    let categorySelectionForm = $( "#blog-category-selection-form" ),
        categorySelectionFormSelect = $('#blog-category-selection'),
        categoryLinkOptions = $('.category-links').find('a');

    categorySelectionFormSelect.on('change', function () {
        categorySelectionForm.submit();
    });

    categorySelectionForm.on('submit', function (e) {
        e.preventDefault();

        categoryLinkOptions.each(function(i, e) {
            let link = $(e),
                href = link.attr('href');

            if(categorySelectionFormSelect.val() === 'all') {
                href = href.replace(/\/tagged\/\w+/, '');
                window.location.href = href;
                return;
            }

            if (href.indexOf(categorySelectionFormSelect.val()) > -1) {
                window.location.href = href;
            }
        })
    });

});
